export const AnimateWork = {
  initial: { opacity: 0, rotate: 20 },
  whileInView: { opacity: 1, rotate: [20, 0, 20, 0, 20, 0] },
  transition: { delay: 0.2, duration: 0.4, repeat: Infinity },
};

export const AnimateProjects = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
};
export const AnimateonClick = {
  initial: { opacity: 0, rotate: 0 },
  animate: { opacity: 1, rotateY: "0", rotateX: "0" },
};
